export class BMWListData {
  area?: string[];
  component?: string[];
  driveConditions?: string[];
  weatherConditions?: string[];
  kindOfNoise?: string[];
  sporadicOrPermanent?: string[];
}